import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteChartById } from '../resources'
import { useToast } from '@cockpitai/hooks/useToast'
import axios from 'axios'
import { KEY_MY_PANELS } from '../keys'

export function useDeletePanelMutation() {
  const { showToast } = useToast()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => deleteChartById(id),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 409) {
          showToast('error', {
            title: 'Erro ao remover painel',
            subtitle:
              'Este painel já foi removido na sessão "Meus Painéis" anteriormente',
          })

          return
        }

        if (error.response?.status === 400) {
          showToast('error', {
            title: 'Erro ao remover painel',
            subtitle: 'Painel não encontrado',
          })

          return
        }
      } else {
        console.error('Unexpected error:', error)
      }

      console.error('Error removing the chart:', error)
    },
    onSuccess: () => {
      showToast('success', {
        title: 'Painel removido com sucesso.',
      })

      queryClient.invalidateQueries({ queryKey: [KEY_MY_PANELS] })
    },
  })
}
